var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.166 2.7566C12.3206 2.91123 12.3206 3.16193 12.166 3.31656L7.41457 8.06798C7.25994 8.22261 7.00924 8.22261 6.85461 8.06798L5.15483 6.3682L1.87124 9.65178C1.71662 9.80641 1.46591 9.80641 1.31128 9.65178C1.15666 9.49716 1.15666 9.24645 1.31128 9.09182L4.87485 5.52826C5.02948 5.37363 5.28018 5.37363 5.43481 5.52826L7.13459 7.22804L11.606 2.7566C11.7607 2.60197 12.0114 2.60197 12.166 2.7566Z",
    fill: "#AC3E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32422 3.03658C8.32422 2.8179 8.50149 2.64062 8.72017 2.64062H11.8878C12.1065 2.64062 12.2837 2.8179 12.2837 3.03658V6.20419C12.2837 6.42287 12.1065 6.60014 11.8878 6.60014C11.6691 6.60014 11.4918 6.42287 11.4918 6.20419V3.43253H8.72017C8.50149 3.43253 8.32422 3.25525 8.32422 3.03658Z",
    fill: "#AC3E31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/TrendUp.721ed8f39aaf74dcd10ecdf3157a2d16.svg";
export { ForwardRef as ReactComponent };